import { createRoutine } from 'redux-saga-routines';

export const clearDiscoverData = createRoutine('CLEAR_DISCOVER');
export const createDiscover = createRoutine('CREATE_DISCOVER');
export const moveDiscoverNode = createRoutine('MOVE_DISCOVER_NODE');
export const moveNodeToNewParent = createRoutine('MOVE_NODE_TO_NEW_PARENT');
export const removeDiscover = createRoutine('REMOVE_DISCOVER');
export const reorderDiscover = createRoutine('REORDER_DISCOVER');
export const sendDiscover = createRoutine('SEND_DISCOVER');
export const stopSyncingDiscover = createRoutine('STOP_SYNCING_DISCOVER');
export const syncDiscover = createRoutine('SYNC_DISCOVER');
export const updateDiscover = createRoutine('UPDATE_DISCOVER');
export const updateDiscoverBranch = createRoutine('UPDATE_DISCOVER_BRANCH');
export const updateDiscoverTreeBackground = createRoutine('UPDATE_DISCOVER_TREE_BACKGROUND_IMAGE');
export const removeAdFromDiscover = createRoutine('REMOVE_AD_FROM_DISCOVER');

export const removeDocumentFromDiscover = createRoutine('REMOVE_DOCUMENT_FROM_DISCOVER');
export const setDiscoverCardStatus = createRoutine('SET_DISCOVER_CARD_STATUS');
export const resetDocumentsToUpload = createRoutine('RESET_DOCUMENTS_TO_UPLOAD');
export const resetAdsToUpload = createRoutine('RESET_ADS_TO_UPLOAD');
